import API from '../../../../../services/api';

export const API_DESCUENTOS_MASIVOS = {
    getDiscounts: async () => {
        return await API.get('/descuentos-masivos').then(res => res.data);
    },
    newDiscount: async (discount) => {
        return API.post('/descuentos-masivos', discount).then(res => res.data);
    },
    updateDiscount: async (discount) => {
        return API.put('/descuentos-masivos/' + discount.id, discount).then(res => res.data);
    },
    sendEmailPrueba: async (data) => {
        return API.post('/descuentos-masivos/send-test-email', data).then(res => res.data);
    },
    sendEmailClientes: async (data) => {
        return API.post('/descuentos-masivos/send-clientes-email', data).then(res => res.data);
    }
}